// ======================================================================
// File Name       : CourseConstants
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import * as ModalIds from './ModalIds';

export const REDIRECT_MODAL = {
  [ModalIds.COURSE_DETAIL]: {
    OK: ModalIds.COURSE_REGISTER_EDIT,
    OK_EXTERNAL: ModalIds.COURSE_EDIT_USER,
  },

  [ModalIds.COURSE_CONFIRM]: {
    CANCEL: ModalIds.COURSE_EDIT_GROUP,
    ERROR: ModalIds.COURSE_REGISTER_EDIT,
  },

  [ModalIds.COURSE_REGISTER_EDIT]: {
    OK: ModalIds.COURSE_EDIT_USER,
  },

  [ModalIds.COURSE_EDIT_USER]: {
    OK: ModalIds.COURSE_EDIT_GROUP,
    CANCEL: ModalIds.COURSE_REGISTER_EDIT,
  },
  [ModalIds.COURSE_EDIT_GROUP]: {
    OK: ModalIds.COURSE_CONFIRM,
    CANCEL: ModalIds.COURSE_EDIT_USER,
  },
};

/**
 * end_condition_type_for_course コース完了条件種別
 * 0: 条件なし(完了しない)
 * 1: 対象アイテムの完了AND条件
 * 2: 対象アイテムの完了OR条件
 * 3: 対象アイテムの完了条件達成率"
 */
export const END_CONDITION_TYPE_FOR_COURSE = {
  NONE: 0,
  AND: 1,
  OR: 2,
  PROGRESS: 3,
};

export const PUBLIC_PERIOD_TYPE = {
  LIMIT: 'LIMIT',
  NO_LIMIT: 'NO_LIMIT',
};

export const CHOSEN_THUMBNAIL = {
  DEFAULT: 0,
  MANUAL: 1,
  NOTHING: -1,
};

export const END_CONDITION_TYPE_FOR_COURSE_LIST = [0, 1, 2, 3];

export const COURSE_GROUP_RELATION_TYPE = {
  DIRECT: 0,
  INDIRECT: 1,
};

export const CERTIFICATE_USE_FLAG = {
  NO_USE: 0,
  USE: 1,
};
